/** Today in Europe/Amsterdam as YYYY-MM-DD (ED-49). */
export function todayIso(): string {
  return new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Amsterdam' })
}
